export default __webpack_public_path__ + "static/media/Wi-Fi-kamera.494e3523.webp";